import { gql } from "@apollo/client";

export default gql`
  fragment MapPointFragment on MapPointParagraph {
    id
    title
    type
    typeLabel
    coordinates {
      latitude
      longitude
    }
    image {
      id
      copyright
      altText
      url
      sm
      md
      lg
      xl
    }
    description
    callToAction {
      title
      url
      target
    }
  }
`;
